import { decodeJWT } from "../../Utils";

import { AuthAction, AuthState, AuthStateProps, Types } from "./Auth.schema";

export const authReducer = (
  state: AuthStateProps,
  action: AuthAction,
): AuthStateProps => {
  let accessToken = "";
  let idToken = "";
  let document = "";
  let username = "";
  let storeDocument = "";
  let login = "";
  let decodedJWT;

  switch (action.type) {
    case Types.setHubToken:
      return {
        ...state,
        hubJWT: {
          accessToken: action.payload.accessToken,
          expiresIn: action.payload.expiresIn,
        },
      };

    case Types.setLegalPersonToken:
      return {
        ...state,
        legalPersonJWT: {
          accessToken: action.payload?.accessToken,
          expiresIn: action.payload?.expiresIn,
          document: action.payload?.document,
          username: action.payload?.username,
        },
      };

    case Types.setUserTokens:
      idToken = action.payload?.idToken;
      accessToken = action?.payload?.accessToken;
      console.log(idToken, "========= TOKEN ID =========");
      if (idToken) {
        decodedJWT = idToken ? decodeJWT(idToken) : {};

        if (decodedJWT) {
          document = decodedJWT?.["custom:document"] || "";
          username = decodedJWT?.["name"] || "";
          storeDocument = decodedJWT?.["custom:store_document"] || "";
          login = decodedJWT?.["custom:login"] || "";
        }
      }
      console.log("STORE DOCUMENT==========", storeDocument);
      return {
        ...state,
        userJWT: {
          accessToken: accessToken,
          expiresIn: action?.payload?.expiresIn,
          refreshToken: action?.payload?.refreshToken,
          idToken,
          document,
          username,
          login,
          storeDocument,
        },
      };

    case Types.setTokens:
      const hubJWT = action?.payload?.hubJWT;
      const userJWT = action?.payload?.userJWT;
      const legalPersonJWT = action?.payload?.legalPersonJWT;

      const payload = {
        ...state,
      };

      if (hubJWT) {
        payload.hubJWT = {
          ...state.hubJWT,
          accessToken: hubJWT?.accessToken,
          expiresIn: hubJWT?.expiresIn,
        };
      }

      if (userJWT) {
        payload.userJWT = {
          ...state.userJWT,
          accessToken: userJWT?.accessToken,
          expiresIn: userJWT?.expiresIn,
          idToken: userJWT?.idToken,
          refreshToken: userJWT?.refreshToken,
        };
      }

      if (legalPersonJWT) {
        payload.legalPersonJWT = {
          ...state.legalPersonJWT,
          accessToken: legalPersonJWT?.accessToken,
          expiresIn: legalPersonJWT?.expiresIn,
          document: legalPersonJWT?.document,
          username: legalPersonJWT?.username,
        };
      }

      return payload;

    case Types.setAccountType:
      return {
        ...state,
        accountType: action?.payload?.accountType,
      };

    case Types.cleanAuth:
      return AuthState;

    default:
      return state;
  }
};
